import type { HTMLAttributes } from 'react';

import { forwardRef, useCallback } from 'react';

interface GDivProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  onClick?: (e?: React.MouseEvent<HTMLDivElement>) => void;
}

export const GDiv = forwardRef<HTMLDivElement, GDivProps>(
  ({ children, onClick, ...props }, ref) => {
    const onKeyDown = useCallback(
      (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.();
        }
      },
      [onClick],
    );

    return (
      <div ref={ref} {...props} role="button" tabIndex={0} onKeyDown={onKeyDown} onClick={onClick}>
        {children}
      </div>
    );
  },
);
GDiv.displayName = 'GDiv';
